import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import {useNavigate} from 'react-router-dom';
import {getUserProfileLink} from '../../utils/helper';
import {faker} from '@faker-js/faker';
import paella from '../../static/images/paella.jpg'
import Stack from '@mui/material/Stack';
import RatingChip from '../common/RatingChip';
import Box from '@mui/material/Box';

export default function AppAvatar() {
  const navigate = useNavigate();

  return <>
    <Stack>
      <Box sx={{textAlign: 'center'}}>
        <Avatar
          onClick={() => {
            navigate(getUserProfileLink())
          }}
          alt={faker.person.firstName()}
          src={paella}
          sx={{width: 42, height: 42, textAlign: 'centre'}}
        />
      </Box>
      {<RatingChip/>}
    </Stack>
  </>
}